<template>
    <v-form v-model="formValid">
        <v-row no-gutters class="d-flex justify-space-around">
            <v-col cols="12">
                <h4>{{ mode === "document" ? "Indiquer un intitulé" : "Intitulé" }}</h4>
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-space-around mt-2">
            <v-col cols="12">
                <v-text-field-filled
                    v-model="title"
                    type="text"
                    placeholder="Ex: Total, Paul..."
                    :mandatory="true"
                    :disabled="mode === 'bank'"
                    :rules="[(v) => !!v || $t('settings.itemRequired')]"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-space-around mt-4">
            <v-col cols="6">
                <h4>{{ mode === "document" ? "Indiquer la date" : "Date" }}</h4>
            </v-col>
            <v-col class="pl-2">
                <h4>Nature de l'opération</h4>
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-space-around mt-2">
            <v-col cols="6">
                <oss-date-picker-filled
                    v-model="date"
                    :filterWithoutClosedAccountingPeriods="true"
                    hide-details
                    :textFieldReadOnly="false"
                    :disabled="mode === 'bank'"
                >
                </oss-date-picker-filled>
            </v-col>
            <v-col cols="6" class="pl-2">
                <AccountableAccountVue
                    :showLabel="true"
                    :showValidation="false"
                    :companyId="companyId"
                    inAccountableAccountType="IncomingOutgoing"
                    :publishedAccounts="true"
                    title="Nature de l'opération"
                    @select-accountableAccount="selectOperationType($event)"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-space-around mt-4">
            <v-col :cols="subjectToVAT ? 4 : 6">
                <h4 v-if="subjectToVAT">Taux de TVA</h4>
            </v-col>
            <v-col cols="4" class="pl-2" v-if="subjectToVAT">
                <h4>Montant TVA</h4>
            </v-col>
            <v-col :cols="subjectToVAT ? 4 : 6" class="pl-2">
                <h4>{{ subjectToVAT ? "Montant TTC" : "Montant" }}</h4>
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-space-around mt-2">
            <v-col :cols="subjectToVAT ? 4 : 6">
                <v-select-filled
                    :items="vatRates"
                    item-value="value"
                    item-title="text"
                    v-model="vatRateValue"
                    v-if="subjectToVAT"
                />
            </v-col>
            <v-col cols="4" class="pl-2" v-if="subjectToVAT">
                <oss-text-field-filled suffix="&#x20ac;" :disabled="true" v-model="vatAmount" />
            </v-col>
            <v-col :cols="subjectToVAT ? 4 : 6" class="pl-2">
                <oss-text-field-filled
                    v-model="grossAmount"
                    suffix="&#x20ac;"
                    :mandatory="true"
                    :disabled="mode === 'bank'"
                />
            </v-col>
        </v-row>
    </v-form>
</template>

<script lang="ts">
import { mathFix } from "../services/mathServices";

import { formatBncAccountingLines } from "../services/bncServices";

import AccountableAccountVue from "./AccountableAccount.vue";

import { vatListIncomingOutgoingPayment } from "@/services/vatServices";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import CREATE_BNC_DOCUMENT from "../graphql/document/CreateBncDocument.gql";
import CREATE_RECONCILIATIONS_WITHOUT_INVOICE from "../graphql/reconciliation/CreateReconciliationsWithoutInvoice.gql";
import { getDBFormattedDate } from "../services/dateServices";

@Component({
    components: {
        AccountableAccountVue,
    },
    emits: ["expenseCreated"],
})
export class IncomingOutgoingPaymentExpense extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "document" }) mode: string;
    @Prop({ default: 0 }) initGrossAmount: number;
    @Prop({ default: "" }) initDate: any;
    @Prop({ default: "" }) initTitle: string;
    @Prop({ default: null }) actions: any;
    @Prop({ default: "" }) bankTransactionId: string;

    formValid: boolean = false;

    bncAccountableAccounts: any = [
        {
            text: "Entretien",
            value: "615000",
        },
        {
            text: "Déplacement",
            value: "625000",
        },
        {
            text: "Frais postaux",
            value: "626000",
        },
    ];

    documentType: string = "PURCHASE_INVOICE";

    // get vatRates() {
    //     const vats = [{ value: "20", vatRate:20, text: '20' },
    //             { value: "10", vatRate: 10, text: '10' },
    //             { value: "8.5", vatRate: 8.5, text: '8.5' },
    //             { value: "5.5", vatRate:5.5, text: '5.5' },
    //             { value: "2.1", vatRate:2.1, text: '2.1' },
    //             // { value: "0", vatRate:0, text: '0 - Inconnue', disabled: true },
    //             { value: "0NO_VAT_TYPE", vatRate:0, text: '0 - Aucun' },
    //             { value: "0INTRACOM", vatRate:0, text: '0 - Intracom' }]
    //     if (this.documentType === "SALES_INVOICE") {
    //             vats.push({ value: "0EXPORT", vatRate:0, text: '0 - Export' })
    //     } else {
    //             vats.push({ value: "0IMPORT", vatRate:0, text: '0 - Import' })
    //     }
    //     vats.push({ value: "0REVERSE_CHARGE", vatRate:0, text: '0 - Autoliquidation' })
    //     // if (this.documentType !== "SALES_INVOICE") {
    //     //     vats.push({ value: 'custom', vatRate:-, text: 'Libre' })
    //     // }

    //     return vats
    // }

    get vatRates() {
        return vatListIncomingOutgoingPayment(this.documentType);
    }

    bankTransactionIds: any = [];

    vatRateValue: string = "20";
    operationType: string = null;

    validTitle: string = "Valider";

    grossAmount: number = 0;
    date: string = "";
    title: string = "";

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get subjectToVAT() {
        return !isNotSubjectToVAT(this.selectedCompany?.vatSystem);
    }

    get vatRate() {
        const vatRate = this.vatRates.find((vr) => vr.value === this.vatRateValue);
        return vatRate.vatRate;
    }

    get vatType() {
        const vatRate = this.vatRates.find((vr) => vr.value === this.vatRateValue);
        if (vatRate?.value?.startsWith("0")) {
            return vatRate.value.substring(1);
        }
        return null;
    }

    beforeMount() {
        if (this.initGrossAmount !== undefined) {
            this.grossAmount = this.initGrossAmount;
        }
        if (this.initDate !== undefined) {
            this.date = this.initDate;
        }
        if (this.initTitle !== undefined) {
            this.title = this.initTitle;
        }

        if (this.bankTransactionId) {
            this.bankTransactionIds.push(this.bankTransactionId);
        }

        if (this.actions?.action) {
            this.actions.action.function = this.validateNewBncOperation;
            this.actions.action.display = true;
            this.actions.action.loading = false;
            this.actions.action.disabled = () => {
                return !this.isValid;
            };
            this.actions.action.title = "Ajouter";
        }
    }

    get netAmount() {
        if (this.grossAmount !== 0 && this.subjectToVAT) {
            return this.grossAmount / (1 + this.vatRate / 100);
        }
        return this.grossAmount;
    }

    get vatAmount() {
        if (this.netAmount && this.subjectToVAT) {
            return mathFix((this.netAmount * this.vatRate) / 100, 2);
        }
        return 0;
    }

    selectOperationType(accountableAccount) {
        this.operationType = accountableAccount.accountableAccount.name;
    }

    resetNewBncOperation() {
        this.grossAmount = 0;
        this.date = "";
        this.title = "";
        this.operationType = null;
    }

    async validateNewBncOperation() {
        if (this.mode === "document") {
            const newBncOperation = {
                grossAmount: this.grossAmount,
                netAmount: this.grossAmount - this.vatAmount,
                vatAmount: this.vatAmount,
                type: this.operationType,
                title: this.title,
                date: this.date,
            };

            const accountingLines = await formatBncAccountingLines(
                this.$store,
                this.$apollo,
                newBncOperation,
                this.companyId,
            );
            debugger;
            const result = await this.$apollo.mutate({
                mutation: CREATE_BNC_DOCUMENT,
                variables: {
                    name: this.title,
                    creditNote: false,
                    date: getDBFormattedDate(this.date),
                    companyId: this.companyId,
                    type: "MISCELLANEOUS_OPERATION",
                    status: "VALIDATED",
                    show: true,
                    vatRate: this.subjectToVAT ? this.vatRate : null,
                    vatType: this.subjectToVAT ? this.vatType : null,
                    grossAmountSigned: this.grossAmount,
                    grossAmount: Math.abs(this.grossAmount),
                    netAmountSigned: this.subjectToVAT ? this.netAmount : null,
                    netAmount: this.subjectToVAT ? this.netAmount : null,
                    vatAmountSigned: this.subjectToVAT ? this.vatAmount : null,
                    vatAmount: this.subjectToVAT ? Math.abs(this.vatAmount) : null,
                    accountingLines: accountingLines,
                    accountingLinesLocked: true,
                    accountingDate: getDBFormattedDate(this.date),
                },
            });

            if (result) {
                console.log("document mode result : ", result);
            }
        } else if (this.mode === "bank") {
            const result = await this.$apollo.mutate({
                mutation: CREATE_RECONCILIATIONS_WITHOUT_INVOICE,
                variables: {
                    bankTransactionIds: this.bankTransactionIds,
                    data: {
                        companyId: this.companyId,
                        vatRate: true,
                        accountableAccountName: this.operationType ? this.operationType : "601000",
                    },
                },
            });

            if (result) {
                console.log("bank result : ", result);
            }
        } else {
            debugger;
        }

        this.$emit("expenseCreated");

        this.resetNewBncOperation();
    }

    get isValid() {
        if (!this.formValid) return false;
        if (!this.date) return false;
        if (!this.operationType) return false;
        if (!this.title) return false;
        if (!this.grossAmount) return false;
        return true;
    }
}

export default toNative(IncomingOutgoingPaymentExpense);
</script>
